import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';

export const createProviderPastePlugin = <T>(
  name: string,
  extract: (text: string) => T | undefined,
  onPastedRef: React.RefObject<((result: T) => void) | null>,
): Extension =>
  Extension.create({
    name,
    priority: 300,
    addProseMirrorPlugins() {
      return [
        new Plugin({
          key: new PluginKey(name),
          props: {
            handlePaste: (_view, event) => {
              if (!onPastedRef.current) return false;

              const text = event.clipboardData?.getData('text/plain');
              if (!text) return false;

              const result = extract(text);
              if (!result) return false;

              onPastedRef.current(result);
              return true;
            },
          },
        }),
      ];
    },
  });
